export function operacaobloqueioprefaturageradaitemInRequest(params = {}) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/RADAPROVARPREFATURA_IN_REQUEST',
    payload: { params },
  };
}

export function veiculosBloqueadosPreFaturaGeradaInRequest(params = {}) {
  return {
    type: '@veiculosbloqueadosprefaturageradainrequest/RADAPROVARPREFATURA_IN_REQUEST',
    payload: { params },
  };
}

export function findoperacaobloqueioprefaturageradaitem(fatu_codigo) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/FIND_RADAPROVARPREFATURA',
    payload: { fatu_codigo },
  };
}

export function findVeiculosBloqueadosPreFaturaGerada(fatu_codigo) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/FIND_VEICULOSPREGERADA',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaobloqueioprefaturageradaitem/FAILED_REQUEST',
  };
}

export function deleteoperacaobloqueioprefaturageradaitem(fatu_codigo, params) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/DELETE_RADAPROVARPREFATURA',
    payload: { fatu_codigo, params },
  };
}

export function updateoperacaobloqueioprefaturageradaitem(
  operacaobloqueioprefaturageradaitem,
  params
) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/UPDATE_RADAPROVARPREFATURA',
    payload: { operacaobloqueioprefaturageradaitem, params },
  };
}

export function storeoperacaobloqueioprefaturageradaitem(
  operacaobloqueioprefaturageradaitem,
  params
) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/STORE_RADAPROVARPREFATURA',
    payload: { operacaobloqueioprefaturageradaitem, params },
  };
}

export function successInRequest(
  operacaobloqueioprefaturageradaitem,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/SUCCESS_IN_REQUEST',
    payload: {
      operacaobloqueioprefaturageradaitem,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaobloqueioprefaturageradaitem) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/SUCCESS_REQUEST',
    payload: { operacaobloqueioprefaturageradaitem },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/RECORD_FILTERING',
    payload: { params },
  };
}

export function recordFilteringVeiculo(params) {
  return {
    type: '@operacaobloqueioprefaturageradaitem/RECORD_FILTERING_VEICULO',
    payload: { params },
  };
}
